import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, image, keywords, noIndex = false }) => {
  const siteTitle = 'SAMP/OPEN.MP - Chơi GTA San Andreas Multiplayer tại PSA Roleplay | PC & Mobile';
  const siteDescription = 'Tham gia trải nghiệm thế giới Roleplay sống động, công việc phong phú, cộng đồng thân thiện và sự kiện hấp dẫn mỗi tuần!';
  const defaultImage = '/resources/images/logo_new.png';
  const siteUrl = 'https://psa.world';
  const defaultKeywords = 'PSA Roleplay, PSA Online, SA-MP Roleplay, máy chủ GTA Việt Nam, gta san roleplay, psa rp, samp server vietnam, gta sa roleplay, gta san andreas roleplay, gta roleplay san andreas, gta san rp, gta mobile roleplay, gta sa mobile roleplay, gta sa mobile vietnam';

  return (
    <Helmet>
      <title>{title ? `${title} | ${siteTitle}` : `${siteTitle}`}</title>
      <meta name="description" content={description || siteDescription} />
      
      {/* Favicon tags */}
      <link rel="icon" href="/resources/images/favicon/favicon.ico" />
      <link rel="apple-touch-icon" sizes="180x180" href="/resources/images/favicon/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/resources/images/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/resources/images/favicon/favicon-16x16.png" />
      <link rel="manifest" href="/resources/images/favicon/site.webmanifest" />
      
      {/* Canonical URL - quan trọng để ngăn nội dung trùng lặp */}
      <link rel="canonical" href={canonical || siteUrl} />
      
      {/* Keywords - vẫn hữu ích cho một số hệ thống */}
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:title" content={title ? `${title} | ${siteTitle}` : `${siteTitle}`} />
      <meta property="og:description" content={description || siteDescription} />
      <meta property="og:image" content={`${siteUrl}${image || defaultImage}`} />
      <meta property="og:locale" content="vi_VN" />
      <meta property="og:site_name" content={siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical || siteUrl} />
      <meta name="twitter:title" content={title ? `${title} | ${siteTitle}` : `${siteTitle}`} />
      <meta name="twitter:description" content={description || siteDescription} />
      <meta name="twitter:image" content={`${siteUrl}${image || defaultImage}`} />
      
      {/* Thêm meta tags cho SEO tiếng Việt */}
      <meta name="language" content="Vietnamese" />
      <meta name="geo.region" content="VN" />
      <meta name="geo.placename" content="Việt Nam" />
      
      {/* Hỗ trợ rich snippets nếu có */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "${siteTitle}",
            "url": "${siteUrl}",
            "logo": "${siteUrl}${defaultImage}",
            "description": "${siteDescription}"
          }
        `}
      </script>
      
      {/* No Index if specified */}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SEO;